// @ts-strict-ignore
/**
 * @owner @Appboy/clip
 */

import React from "react";

import { setElevatedAccessToasts } from "@lib/elevatedAccess/elevatedAccessToasts";

import useI18nNamespace from "@services/useI18nNamespace";

export const ElevatedAccessToasts = ({ children }) => {
  const { t } = useI18nNamespace("elevated-access");
  setElevatedAccessToasts(t);

  return <>{children}</>;
};
